module.exports = __webpack_public_path__ + "media/images/front/pc/default/noimage_s190x190-7dc89e5f030d4a3deef4b2688e6cbdf4.png";